import { delay, HttpResponse } from 'msw';

import { mockMatchListsSelectOperationQuery } from 'core/graphql';

export const TEST_MATCH_LIST_SELECT_NAME = 'testMatchList';

export const handlers = [
  mockMatchListsSelectOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          matchLists: {
            __typename: 'MatchListPage',
            total: 1,
            objects: [
              {
                __typename: 'MatchList',
                id: '1',
                name: TEST_MATCH_LIST_SELECT_NAME,
              },
            ],
          },
        },
      });
    }
  ),
];
